module.exports = __webpack_public_path__ + "static/img/5.b3683fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/sp/5.png
// module id = 0F4D
// module chunks = 0